import { Command } from "@ckeditor/ckeditor5-core";
import { first } from "@ckeditor/ckeditor5-utils";

export default class BlockStyleCommand extends Command {
  execute({ label }) {
    const model = this.editor.model;

    const blocksToChange = getBlocksToChange(model);

    model.change((writer) => {
      const options = this.editor.config.get("blockStyles.options");
      resetBlocks(writer, this.editor, options, blocksToChange);
      const option = options.find((o) => o.label === label);
      if (option && option.model) {
        switch (option.view.name) {
          case "div":
            wrapBlocks(writer, blocksToChange, option.model);
            break;
          case "ct":
          case "h3":
          case "h4":
          case "h5":
            this.editor.execute("heading", { value: option.model });
            break;
          default:
            for (const block of blocksToChange) {
              if (block.name === "paragraph")
                writer.rename(block, option.model);
            }
        }
      }
    });
  }

  refresh() {
    const model = this.editor.model;
    const options = this.editor.config
      .get("blockStyles.options")
      .map((o) => o.model);
    const block = first(model.document.selection.getSelectedBlocks());
    const namedAncestor =
      !!block &&
      block
        .getAncestors({ includeSelf: true })
        .find((o) => options.includes(o.name));
    this.isEnabled = true;
    this.value = !!namedAncestor && namedAncestor.name;
  }
}

function getBlocksToChange(model) {
  const selection = model.document.selection;
  return Array.from(selection.getSelectedBlocks());
}

function resetBlocks(writer, editor, options, blocks) {
  for (const block of blocks) {
    block
      .getAncestors({
        includeSelf: true,
      })
      .filter((o) => !!o.parent)
      .map((a) => {
        const option = options.find((o) => o.model === a.name);
        if (option) {
          switch (option.view.name) {
            case "div":
              writer.unwrap(a);
              break;
            case "ct":
            case "h3":
            case "h4":
            case "h5":
              editor.execute("paragraph");
              break;
            default:
              writer.rename(a, "paragraph");
          }
        }
      });
  }
}

function wrapBlocks(writer, blocks, name) {
  let endPosition, startPosition;

  for (const block of blocks) {
    if (!startPosition) startPosition = writer.createPositionBefore(block);
    endPosition = writer.createPositionAfter(block);
  }
  const range = writer.createRange(startPosition, endPosition);
  const el = writer.createElement(name);

  writer.wrap(range, el);
}
